export function calculateGTMScore(data){

if(!data) return 0;

let score = 0;

/* normalize sections */

const execution =
data.execution || data.channels || [];

const sections = [

data.strategy,
data.icp,
data.positioning,
execution,
data.experiments,
data.roadmap,
data.metrics,
data.risks,
data.checklist

];

/* section coverage */

sections.forEach(section=>{

if(section && section.length>0)
score += 10;

});

/* execution intelligence */

const intelligentExecution =

execution.some(x=>x?.priority) ||
(data.experiments || []).some(x=>x?.priority);

if(intelligentExecution)
score += 10;

/* normalize to 10 scale */

score =
Math.round((score/100)*10);

/* safety */

if(isNaN(score))
return 0;

return score;

}